import React from "react";
import { Box, Typography } from "@mui/material";
import ReportIcon from "@mui/icons-material/Report";

const NoteSection = () => {
  const noteIntro = "Important Note:";
  const noteBody =
    "Box contents may vary depending on ingredient availability. Our kitchen is not allergen-free. If you have severe allergies, we recommend not ordering.";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        mt: 4,
        mb: 4,
        backgroundColor: "#FFF7E6",
        borderLeft: "4px solid #FFA000",
        p: 2.5,
        borderRadius: 2,
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
      }}>
      <ReportIcon sx={{ mr: 2, color: "#FFA000", mt: 0.3 }} />
      <Box>
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 700,
            color: "#5F370E",
            mb: 0.5,
            letterSpacing: 0.5,
            textTransform: "uppercase",
            fontSize: "0.8rem",
          }}>
          {noteIntro}
        </Typography>
        <Typography
          sx={{
            color: "#5F370E",
            fontWeight: 500,
            fontSize: "0.95rem",
            lineHeight: 1.6,
            letterSpacing: 0.2,
          }}>
          {noteBody}
        </Typography>
      </Box>
    </Box>
  );
};

export default NoteSection;
